import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadNodeStateFailed, loadNodeStateSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadNodeState(action) {
  try {
    const dataResponse = yield makeRequest(`${BACKEND_URL}/state`, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadNodeStateSuccessful(data.data || {}));
      yield call(resolveActionPromise(action, data.data || {}));
    } else {
      yield put(loadNodeStateFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadNodeStateFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
